import React from "react";
import "../style/link.scss";

export default function Krug() {
  return <div className="krug">&#8594;</div>;
}
